import { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult({ success }) {
  const location = useLocation();
  const [status, setStatus] = useState("checking");
  const { refresh } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!success) { setStatus("cancelled"); return; }
    const params = new URLSearchParams(location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }

    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refresh();
          setTimeout(() => navigate("/tableau-de-bord"), 2500);
          return;
        }
        if (attempts < 20) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch {
        setStatus("error");
      }
    };
    poll();
  }, [location.search, success, refresh, navigate]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-32 max-w-2xl mx-auto px-4 text-center" data-testid="payment-result">
        <div className="glass rounded-2xl p-12">
          {status === "checking" && (
            <>
              <Loader2 className="mx-auto animate-spin text-indigo-400" size={40} />
              <h1 className="mt-6 text-2xl font-bold">Confirmation du paiement…</h1>
              <p className="text-gray-400 mt-2">Cela ne prend que quelques secondes.</p>
            </>
          )}
          {status === "paid" && (
            <>
              <CheckCircle2 className="mx-auto text-emerald-400" size={48} />
              <h1 className="mt-6 text-2xl font-bold">Merci ! Votre forfait est actif.</h1>
              <p className="text-gray-400 mt-2">Redirection vers votre tableau de bord…</p>
            </>
          )}
          {(status === "cancelled" || status === "error" || status === "timeout") && (
            <>
              <XCircle className="mx-auto text-red-400" size={48} />
              <h1 className="mt-6 text-2xl font-bold">
                {status === "cancelled" ? "Paiement annulé" : "Un souci est survenu"}
              </h1>
              <p className="text-gray-400 mt-2">Vous pouvez réessayer quand vous voulez.</p>
              <Link to="/tarifs" className="pill-primary inline-block mt-6" data-testid="retry-pricing-link">Retour aux tarifs</Link>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
